module.exports = {
  env: 'development',
  domain: ['dev.nges.qq.com'],
  mobileDomain: 'devh5.nges.qq.com',
  aegisId: 'jlZIRgHXbxAFIWbChO',
  reportDomain: 'baike.sparta.html5.qq.com',
};
